// components/TermsReminderModal.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReminderManager from "./ReminderManager";

const TermsReminderModal = ({ onClose, onSuccess }) => {
  const navigate = useNavigate();
  const [actionTaken, setActionTaken] = useState(false);

  const handleSetupNow = () => {
    ReminderManager.handleUserAction(
      ReminderManager.TERMS_REMINDER_KEY,
      "redirecting"
    );
    setActionTaken(true);
    navigate("/garageterms?showModal=true");
    if (onSuccess) onSuccess();
  };

  const handleCancel = () => {
    ReminderManager.handleUserAction(
      ReminderManager.TERMS_REMINDER_KEY,
      "canceled"
    );
    if (onClose) onClose();
  };

  const handleSkip = () => {
    ReminderManager.handleUserAction(
      ReminderManager.TERMS_REMINDER_KEY,
      "skipped"
    );
    if (onClose) onClose();
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <div style={styles.icon}>📝</div>
          <h3 style={styles.title}>Setup Terms & Conditions</h3>
          <p style={styles.subtitle}>
            Add your garage terms
            <br />
            for better customer understanding
          </p>
        </div>

        <div style={styles.content}>
          <div style={styles.benefits}>
            <div style={styles.benefitItem}>
              <span style={styles.benefitIcon}>✅</span>
              <span>
                These terms will also show on the estimate page and in print
              </span>
            </div>
            <div style={styles.benefitItem}>
              <span style={styles.benefitIcon}>✅</span>
              <span>Set clear expectations with customers</span>
            </div>
            <div style={styles.benefitItem}>
              <span style={styles.benefitIcon}>✅</span>
              <span>Reduce disputes and misunderstandings</span>
            </div>
            <div style={styles.benefitItem}>
              <span style={styles.benefitIcon}>✅</span>
              <span>Professionalize your garage operations</span>
            </div>
          </div>
        </div>

        <div style={styles.buttonGroup}>
          <button
            type="button"
            onClick={handleSetupNow}
            style={styles.primaryButton}
            disabled={actionTaken}
          >
            {actionTaken ? "Redirecting..." : "Setup Terms"}
          </button>
           <div type="button" style={{textAlign:"right"}} onClick={handleCancel} disabled={actionTaken}>
          Remind me later
        </div>
        </div>
       
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
          100% {
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: "20px",
    animation: "fadeIn 0.3s ease-out",
  },
  modal: {
    backgroundColor: "white",
    borderRadius: "16px",
    width: "100%",
    maxWidth: "500px",
    overflow: "hidden",
    boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
  },
  header: {
    padding: "12px 24px 10px",
    background: "linear-gradient(135deg, #00409e 0%, #00409e 100%)",
    color: "white",
    textAlign: "center",
  },
  icon: {
    fontSize: "48px",
    marginBottom: "12px",
    animation: "pulse 2s infinite",
  },
  title: {
    margin: "0 0 8px 0",
    fontSize: "22px",
    fontWeight: "700",
  },
  subtitle: {
    margin: "0",
    fontSize: "14px",
    opacity: "0.9",
  },
  content: {
    padding: "10px",
  },
  benefits: {
    // marginBottom: "24px",
  },
  benefitItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "5px",
    fontSize: "14px",
    color: "#2d3748",
  },
  benefitIcon: {
    marginRight: "12px",
    fontSize: "16px",
  },
  note: {
    padding: "12px",
    backgroundColor: "#f0f9ff",
    borderRadius: "8px",
    color: "#0369a1",
    fontSize: "13px",
    textAlign: "center",
    border: "1px solid #bae6fd",
  },
  buttonGroup: {
    display: "block",
    gap: "12px",
    padding: "16px 24px 24px",
    backgroundColor: "#f8fafc",
    borderTop: "1px solid #e2e8f0",
  },
  skipButton: {
    flex: 1,
    padding: "14px",
    backgroundColor: "transparent",
    color: "#64748b",
    border: "2px solid #e2e8f0",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s",
  },
  cancelButton: {
    flex: 1,
    padding: "14px",
    backgroundColor: "#f1f5f9",
    color: "#475569",
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s",
  },
  primaryButton: {
    flex: 2,
    width:"100%",
    padding: "14px",
    backgroundColor: "#4f46e5",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s",
  },
};

export default TermsReminderModal;
